export default __webpack_public_path__ + "static/media/eltonJohn.4f313e7e.jpeg";